import '@/common/styles/main.scss';
import { initializeBehaviors } from "@/common/behaviors/initialize-behaviors";
import flatpickr from 'flatpickr';
import dbg from './common/utils/diagnostics';
import type { SentryContext } from "@/common/types";

console.log("[app-startup] core-app loaded ");

declare global {
    interface Window {
        [index: string | number]: any;
        qaContext: SentryContext;
    }
}

window.flatpickr = flatpickr;
window.bootstrap = require('bootstrap');

$(()=>{
        
    console.log("[app-startup] core-app initializing 🚀 ");
    
    //********************************
	// Initialize Diagnostic Context
	//********************************
    if (typeof window.qaContext != "undefined"){
        dbg.initializeContext(window.qaContext);
    }

    //********************************
	// Validate core libraries
	//********************************
    const deps = ["$", "jQuery", "bootstrap", "flatpickr"];

    deps.forEach(dep =>{
        if (typeof window[dep] === "undefined") {
            console.error(`jserror:${dep}-missing`);
        }
    });

    // Initialize common utilities based on
    // the window.pageBehaviors variable.
    initializeBehaviors();
});
